import InventionsTable from './inventionsTableMui/InventionsTableMui'
import styles from './Report.module.scss'

import { ReportData } from 'store/dashboard/types'
import CompaniesTable from './companiesTable/CompaniesTable'
import SectionContainer from 'containers/dashboard/components/SectionContainer'
import SectionHeader from 'containers/dashboard/components/SectionHeader'
import { Box, Paper } from '@mui/material'
import SectionSubTitle from 'containers/dashboard/components/SectionSubtitle'

type Props = {
  isPdfPrinter?: boolean
  reportData: ReportData
}

export default function Report({ isPdfPrinter = false, reportData }: Props) {
  return (
    <Box mb={4}>
      <div className={isPdfPrinter ? styles.pdfPrinter : ''}>
        <>
          {reportData.primary_patents && reportData.primary_patents.length > 0 && (
            <SectionContainer>
              <SectionHeader title="Primary Inventions"></SectionHeader>
              <Paper variant="outlined" sx={{ borderRadius: '20px', m: 3, mt: 0 }}>
                <SectionSubTitle title="a) All Territories (excluding CN)"></SectionSubTitle>
                <InventionsTable patents={reportData.primary_patents} />
              </Paper>
            </SectionContainer>
          )}

          <SectionContainer>
            <SectionHeader title="Similar Inventions"></SectionHeader>
            <Paper variant="outlined" sx={{ borderRadius: '20px', m: 3, mt: 0 }}>
              <SectionSubTitle title="a) All Territories (excluding CN)"></SectionSubTitle>
              <InventionsTable patents={reportData.top_non_primary_patents_except_cn} />
            </Paper>
            <Paper variant="outlined" sx={{ borderRadius: '20px', m: 3, mt: 0 }}>
              <SectionSubTitle title="b) China (excluding all other territories)"></SectionSubTitle>
              <InventionsTable patents={reportData.top_non_primary_patents_for_cn} />
            </Paper>
          </SectionContainer>
          <SectionContainer>
            <div className={styles.pageBreak}></div>
            <SectionHeader title="Similar Companies"></SectionHeader>
            <Paper variant="outlined" sx={{ borderRadius: '20px', m: 3, mt: 0 }}>
              <SectionSubTitle title="a) All Territories (excluding CN)"></SectionSubTitle>
              <CompaniesTable applicants={reportData.top_applicants_except_cn} />
            </Paper>
            <Paper variant="outlined" sx={{ borderRadius: '20px', m: 3, mt: 0 }}>
              <SectionSubTitle title="b) China (excluding all other territories)"></SectionSubTitle>
              <CompaniesTable applicants={reportData.top_applicants_for_cn} />
            </Paper>
          </SectionContainer>

          <Box sx={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>
            {` • In the Beta version the patent claims only are analysed to identify relevance. 
• The Beta version uses patent data available up to February 2023. 
• If priority year is missing, publication year is shown instead (marked with *) 
• The patent number will link to the patent identified. 
• 'No. in family' means 'Number of patents in Patent Family' 
• '**'' means 'Grouped because title and applicant are the same'`}
          </Box>
        </>
      </div>
    </Box>
  )
}
